import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useAppContext } from "../../../_context";
import Button from "../../Misc/Button";
import Image from "next/image";
import HighlightedString from "../../Misc/HighlightedString";

const Hero = () => {
  const [{ tx: strings }] = useAppContext();
  const label = (
    <>
      <h1 className="mb-3">
        <HighlightedString
          text={strings["The [smart] way to [engage] your members"]}
        />
      </h1>
      <p>
        {
          strings[
            "Create an online hub for your club members, boost court usage and increase new member registrations."
          ]
        }
      </p>
      <Button href="/clubs/signup">{strings["Get started"]}</Button>
    </>
  );

  return (
    <>
      <section className="hero hero-height position-relative overflow-hidden">
        <Container>
          <Row className="flex-md-nowrap">
            <Col md={6} className="position-relative order-md-2">
              <Image
                src="/img/heroes/clubs.jpg"
                layout="fill"
                objectFit="cover"
                objectPosition="top"
                unoptimized={true}
              />
            </Col>
            <Col md={6} className="d-none d-md-flex align-items-center">
              <div className="w-100 pe-3">{label}</div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="d-block d-md-none">
        <Container>
          <Row>
            <Col xs={12} className="py-4">
              {label}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Hero;
